const pricingConfigDetails = (state = null, action) => {
  if (action.type === "SET_PRICING_CONFIG_DETAILS") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_PRICING_CONFIG_DETAILS": {
  //     return action.payload;
  //   }
  
  //   default: {
  //     return state;
  //   }
  // }
};

export default pricingConfigDetails;
